const GameToolbar = require('./game-toolbar.js')

module.exports = function Toolbar (state, emit) {
  return GameToolbar(state, emit)
}
